import {FeedContent} from 'components/Feed/FeedCard'
import {FeedCard} from 'components/Feed/TimeLineFeed'
import LazyComponent from 'components/LazyComponent'
import Pure from 'components/Pure'
import _ from 'lodash'
import React from 'react'
import {FeedActionTypes, FeedContentTypes} from 'views/Feed/Feed'
import {GoogleAdsInFeedUnit} from '../../../components/GoogleAds/GoogleAds'
import {FeedWidget} from '../../NewFeed/FeedWidget'
import renderFeedAskItem, {renderQAHeadLine} from './renderFeedAskItem'
import {renderHeadlineFeedItem} from './renderNewsItem'
import {GodWordsBlock} from "../components/GodWordsBlock";
import {PulseBox, PulseCircle, PulseLine} from "../../../components/EmptyHolder/helpers";

const renderExcludedItem = (item, index) => {
    switch (item.action) {
        case FeedActionTypes.ADS:
            return <GoogleAdsInFeedUnit/>
        case FeedActionTypes.WOG:
            return <GodWordsBlock/>
        case FeedActionTypes.STICKY:
            return (
                <LazyComponent>
                    <Pure>
                        <FeedWidget item={item}/>
                    </Pure>
                </LazyComponent>
            )
        default:
            return null
    }
}

const renderCard = (item, customComponents = {}) => (
    <FeedCard
        key={item.id}
        item={item.content}
        customComponents={customComponents}
    />
)

export const renderFeedItem = (item, index) => {
    if (!item) return null
    if (_.includes(Object.values(FeedActionTypes), item.action)) {
        return renderExcludedItem(item, index)
    }
    return renderCard(item, {
        Content: FeedContent,
    })
}

const FeedItemLoading = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 0, padding: '12px 0'}}>

            {/* Header: Avatar + Name + Time + Follow + ··· */}
            <div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, paddingLeft: 12, paddingRight: 12}}>
                <PulseCircle size={38}/>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 5}}>
                    <PulseLine width="60%" height={13}/>
                    <PulseLine width="45%" height={11}/>
                </div>
                <PulseBox width={60} height={24} borderRadius={12}/>
                <PulseCircle size={20}/>
            </div>

            {/* Title + subtitle */}
            <div style={{display: 'flex', flexDirection: 'column', gap: 6, paddingLeft: 12, paddingRight: 12, marginBottom: 10}}>
                <PulseLine width="90%" height={14}/>
                <PulseLine width="75%" height={12}/>
            </div>

            {/* Video thumbnail */}
            <PulseBox height={200} borderRadius={0}/>

            {/* Link preview bar */}
            <div style={{display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderBottom: '1px solid #f0f0f0'}}>
                <PulseCircle size={14}/>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 5}}>
                    <PulseLine width="80%" height={13}/>
                    <PulseLine width="60%" height={11}/>
                </div>
            </div>

            {/* Xem bài viết */}
            <div style={{display: 'flex', justifyContent: 'flex-end', padding: '6px 12px 10px'}}>
                <PulseLine width={80} height={11}/>
            </div>

            {/* Action bar: Thích / Bình luận / Chia sẻ */}
            <div style={{display: 'flex', borderTop: '1px solid #f0f0f0', paddingTop: 8, paddingLeft: 12, paddingRight: 12}}>
                {[1, 2, 3].map(i => (
                    <div key={i} style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6}}>
                        <PulseCircle size={16}/>
                        <PulseLine width={50} height={12}/>
                    </div>
                ))}
            </div>

        </div>
    )
}

export const renderFeedLoading = () => (
    <div className="space-y-6 flex flex-col">
        <FeedItemLoading />
        <FeedItemLoading />
    </div>
)

export const renderFeedByType = (type) => (item, index) => {
    if (!item) return null

    if (_.includes(Object.values(FeedActionTypes), item.action)) {
        return renderExcludedItem(item, index)
    } else {
        const _type = type === 'all' ? _.get(item, 'content._type') : type
        switch (_type) {
            case FeedContentTypes.ARTICLE:
                return renderCard(item, {
                    Content: () => <FeedContent/>,
                })
            case FeedContentTypes.ASK:
                return renderFeedAskItem(item, index)
            default:
                return renderFeedItem(item, index)
        }
    }
}

export const renderFeedHeadlineByType = (type) => (item, index) => {
    if (!item) return null

    if (_.includes(Object.values(FeedActionTypes), item.action)) {
        return renderExcludedItem(item, index)
    } else {
        let content = renderHeadlineFeedItem(item)
        const _type = type === 'all' ? _.get(item, 'content._type') : type
        switch (_type) {
            case FeedContentTypes.ASK:
                return renderQAHeadLine(item, index)
            case FeedContentTypes.ARTICLE:
            default:
                break
        }

        return <React.Fragment key={index}>{content}</React.Fragment>
    }
}
